import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { HttpLoaderFactory } from "@/_services/http-loader-factory";


import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { SelectCountryCodeModalModule } from '@/_modals/select-country-code-modal/select-country-code-modal.module';
import { SelectServiceModalModule } from '@/_modals/select-service-modal/select-service-modal.module';
import { SelectGuestLogModalModule } from '@/_modals/select-guestlog-modal/select-guestlog-modal.module';
import { SelectUserModalModule } from '@/_modals/select-user-modal/select-user-modal.module';
import { JwtInterceptor, ErrorInterceptor } from "@/_guards";

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserModule, 
		BrowserAnimationsModule,
		SelectUserModalModule,
		SelectServiceModalModule,
		SelectGuestLogModalModule,
		SelectCountryCodeModalModule,
		HttpClientModule,
		IonicModule.forRoot(), 
		AppRoutingModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient],
			},
		}),
	],
	providers: [
		{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
		{ provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
